import styled from 'styled-components'

export const ForgotPasswordBottomText = styled.div`
    font-size: 12px;
    line-height: 15px;
    margin-top: 74.5px;
    display: flex;
    align-content: center;
    justify-content: center;
    @media screen and (max-width: 599px) {
        margin-top: 30px;
    }
`

export const ForgotPasswordBottomLink = styled.div`
    margin-left: 5px;
    text-decoration: underline;
    &:hover {
        cursor: pointer;
    }
`
